import {
  ICON_BULLHORN_OUTLINE, ICON_CALENDAR_MULTISELECT_OUTLINE, ICON_CASH_MULTIPLE, ICON_HANDSHAKE_OUTLINE,
} from '@doveit/bricks';
import { MetricFrequency } from './types';
import { GoalMetric } from '../../../providers/api/dtos/goals';

export const configByMetric: Record<GoalMetric, {
  icon: string,
  label: string,
  info: string,
}> = {
  rumors: {
    icon: ICON_BULLHORN_OUTLINE,
    label: 'Notizie',
    info: 'Il numero di notizie settimanali è calcolato sulla base di un CR1 medio (appuntamenti/notizie) del 25%.',
  },
  prospects: {
    icon: ICON_CALENDAR_MULTISELECT_OUTLINE,
    label: 'Valutazioni',
    info: 'Il numero di valutazioni settimanali è calcolato sulla base di un CR2 medio (mandati/valutazioni) del 25%.',
  },
  assignments: {
    icon: ICON_HANDSHAKE_OUTLINE,
    label: 'Mandati',
    info: 'Il numero di mandati mensili è calcolato sulla base di un CR3 medio (vendite/mandati) del 35%.',
  },
  sales: {
    icon: ICON_CASH_MULTIPLE,
    label: 'Vendite',
    info: 'Il numero di vendite è calcolato sulla base di un 50% di vendite derivanti da notizie e 50% derivanti da lead Dove e una commissione media di {AVG_COMMISSION}.',
  },
};

export const frequencyLabels: Record<MetricFrequency, string> = {
  weekly: 'a settimana da ora',
  monthly: 'al mese da ora',
};
